/**
 * Utility function to make titles human-readable
 * Converts slugs like "san-francisco" to "San Francisco"
 */
export function formatTitle(slug: string): string {
  return slug
    .split("-") // Split by hyphen
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(" "); // Join words with a space
}
